import React, { useState, useEffect } from "react";
import { authService } from "../services/auth";

const CreateUser = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [role, setRole] = useState("user"); // Default role
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentUserRole, setCurrentUserRole] = useState(null); // Novo estado para a role do usuário logado

  useEffect(() => {
    const fetchUserRole = async () => {
      const role = await authService.getCurrentUserRole();
      setCurrentUserRole(role);
    };
    fetchUserRole();
  }, []);

  const validateEmail = (email) => {
    // Aceita emails normais e domínios de teste (example.com, test.com, localhost, etc)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    // Validação do email
    if (!validateEmail(email)) {
      setError("Email inválido. Use um formato válido (ex: usuario@dominio.com)");
      setLoading(false);
      return;
    }

    try {
      await authService.signUp(email, password, {
        full_name: fullName,
        role: role,
      });
      setMessage(`Usuário ${email} criado com sucesso com a função '${role}'.`);
      // Limpar formulário
      setEmail("");
      setPassword("");
      setFullName("");
      setRole("user");
    } catch (err) {
      setError(err.message || "Erro ao criar usuário");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-4 sm:p-6 lg:p-8">
      <div className="w-full max-w-md">
        <div className="bg-white px-8 py-12 shadow-lg rounded-lg">
          <h4 className="text-2xl font-bold text-neutral-800 mb-6">
            Criar Novo Utilizador
          </h4>
          <form onSubmit={handleCreateUser}>
            {error && (
              <div
                className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6"
                role="alert"
              >
                {error}
              </div>
            )}
            {message && (
              <div
                className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-6"
                role="alert"
              >
                {message}
              </div>
            )}
            <div className="mb-4">
              <label className="block text-sm text-neutral-700 mb-2">
                Nome Completo
              </label>
              <input
                type="text"
                placeholder="Digite o nome completo"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm text-neutral-700 mb-2">
                Email
              </label>
              <input
                type="text"
                placeholder="Digite o email (ex: usuario@dominio.com ou admin@example.com)"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm text-neutral-700 mb-2">
                Senha
              </label>
              <input
                type="password"
                placeholder="Crie uma senha forte"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
              />
            </div>
            {currentUserRole === "admin" && (
              <div className="mb-4">
                <label className="block text-sm text-neutral-700 mb-2">
                  Função (Role)
                </label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                >
                  <option value="user">Usuário</option>
                  <option value="supervisor">Supervisor</option>
                  <option value="admin">Administrador</option>
                </select>
              </div>
            )}{" "}
            {/* Fim da condição para exibir o seletor de role */}
            <button
              type="submit"
              disabled={loading}
              className="bg-neutral-900 text-white px-4 py-2 rounded-md hover:bg-neutral-800 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Criando..." : "Criar Usuário"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
